import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { Button } from '@mui/material';

import Logo from './logo.svg'
import Logo1 from './logo1.svg'
import TodayAll from 'components/TimeAll';
import LogoutPage from 'pages/logout';
import { useEnumApi } from 'contexts/EnumApiContext';
import MenuInfo from 'data/menu';
import { getBrowserTitle, useTitle } from 'data/data';
import { ROLE } from 'data/data';
import ThemeToggleButton from "components/ThemeToggleButton";
import { useTheme } from "components/ThemeContext";
import LogoImg from "components/LogoImg";

function NavLink({eventKey, href, className, style, children}) {
  let navigate = useNavigate();
  return (
    <Nav.Item>
      <Nav.Link eventKey={eventKey} href="#" onClick={(eventKey) => { /*console.log(href);*/ navigate(href); }} className={className} style={style}>{children}</Nav.Link>
    </Nav.Item>
  );
}

export default function Navigationbar() {
  const monitoring = MenuInfo.CMMS;
  const hostname = window.location.hostname;
  // const management = MenuInfo.MANAGEMENT;
  // const monitoring = MenuInfo.ROOT;
  // const report_dataroom = MenuInfo.CMMS_REPORT_DATAROOM;
  // const setting = MenuInfo.CMMS_MANAGEMENT;
  const { mode } = useTheme();
  const { t } = useTranslation();
  const { role } = useEnumApi();
  const { name } = useSelector(state => state.user);
  const changeTitle = useTitle();
  useEffect(()=>{
    changeTitle(getBrowserTitle(hostname));
  }, [])

  const [logoPath, setLogoPath] = useState(Logo);
  useEffect(()=>{
    setLogoPath(mode === 'white' ? Logo1 : Logo);
  }, [mode])

  const fullpath = useLocation().pathname;
  const className1 = "dark";
  const className2 = "";
  const className3 = "";
  const className4 = "";
  const className5 = "#FFF";
  // const logoPath = Logo;
  // const className1 = (fullpath.indexOf(report_dataroom.fullpath) != -1 || fullpath.indexOf(setting.fullpath) != -1) ? "light" : "dark";
  // const className2 = (fullpath.indexOf(report_dataroom.fullpath) != -1 || fullpath.indexOf(setting.fullpath) != -1) ? "mro_navbar" : "";
  // const className3 = (fullpath.indexOf(report_dataroom.fullpath) != -1 || fullpath.indexOf(setting.fullpath) != -1) ? "#707071" : "";
  // const className4 = (fullpath.indexOf(report_dataroom.fullpath) != -1 || fullpath.indexOf(setting.fullpath) != -1) ? " white_m_account" : "";
  // const className5 = (fullpath.indexOf(report_dataroom.fullpath) != -1 || fullpath.indexOf(setting.fullpath) != -1) ? "#000" : "#FFF";
  // const logoPath = (fullpath.indexOf(report_dataroom.fullpath) != -1 || fullpath.indexOf(setting.fullpath) != -1) ? Logo1 : Logo;
  return (
    <Navbar collapseOnSelect expand="xxl" bg={className1} variant={className1} className={className2}>
    {/* <Navbar collapseOnSelect expand="xxl" bg="dark" variant="dark"> */}
      <div className='mobile_top'>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Brand href="/"><LogoImg />{/* <img src={logoPath} alt="logo" /> */}</Navbar.Brand>
        <div></div>
      </div>
      
      <div className='pc_account'>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav>
            {
              // monitoring.children.map((child) => <NavLink key={child.id} eventKey={child.id} href={child.fullpath} className={child.isActive ? "active": ""}>{child.name}</NavLink>)
              monitoring.children.map((child) => <NavLink key={child.id} eventKey={child.id} href={child.fullpath} className={monitoring.isActive && child.isActive ? "active": ""}>{child.name}</NavLink>)
            }
            {/* <NavLink eventKey={report_dataroom.id} href={report_dataroom.fullpath} className={report_dataroom.isActive ? "active": ""}>{report_dataroom.name}</NavLink>
            { (role === ROLE.SA.code || role === ROLE.WA.code) &&
            <NavLink eventKey={setting.id} href={setting.fullpath} className={setting.isActive ? "active": ""}>{setting.name}</NavLink>
            } */}
          </Nav>

          <Nav>
            <TodayAll style={{ color : `${className3}`}}/>
          </Nav>
          
          <Nav style={{alignItems:"center",color:"#fff",fontSize:"1rem"}}>
            <NavLink style={{alignItems:"center",color:`${className5}`,fontSize:"1rem"}}>
              <div style={{display:"flex", alignItems:"center"}}>
                <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/account_circle.png`} alt='' /></span>
                <span style={{padding:"0 7px"}}>{name}</span>
              </div>
            </NavLink>
            <ThemeToggleButton />
            <NavLink href="/"><LogoutPage /></NavLink>
            {/* <NavLink href={management.fullpath}><Button variant="contained">{t('message.common.btn.management.maintenance')}</Button></NavLink> */}
          </Nav>

        </Navbar.Collapse>
      </div>

      <div className={`m_account${className4}`}>
        <Navbar.Collapse id="responsive-navbar-nav">

          <div className='m_account_top'>
            <Nav style={{paddingTop:"3px"}}>
              <TodayAll style={{ color : `${className3}`}}/>
            </Nav>
            
            <Nav className="m_account_in" style={{display:"flex",alignItems:"center",color:`${className5}`,fontSize:"1rem"}}>
              <NavLink style={{alignItems:"center",color:`${className5}`,fontSize:"1rem"}}>
                <div style={{display:"flex", alignItems:"center"}}>
                  <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/account_circle.png`} alt='' /></span>
                  <span style={{padding:"0 7px"}}>{name}</span>
                </div>
              </NavLink>
              <NavLink href="/"><LogoutPage /></NavLink>
              {/* <NavLink href={management.fullpath}><Button variant="contained">{t('message.common.btn.management.maintenance')}</Button></NavLink> */}
            </Nav>
          </div>

          <Nav className='dark_menu m_menu_btn'>
            {
              // monitoring.children.map((child) => <NavLink key={child.id} eventKey={child.id} href={child.fullpath} className={child.isActive ? "active": ""}>{child.name}</NavLink>)
              monitoring.children.map((child) => <NavLink key={child.id} eventKey={child.id} href={child.fullpath} className={monitoring.isActive && child.isActive ? "active": ""}>{child.name}</NavLink>)
            }
            {/* <NavLink eventKey={report_dataroom.id} href={report_dataroom.fullpath} className={report_dataroom.isActive ? "active": ""}>{report_dataroom.name}</NavLink>
            { (role === ROLE.SA.code || role === ROLE.WA.code) &&
            <NavLink eventKey={setting.id} href={setting.fullpath} className={setting.isActive ? "active": ""}>{setting.name}</NavLink>
            } */}
          </Nav>

        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}
